import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function headers(extra = {}) {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  return { ...(t ? { Authorization: `Bearer ${t}` } : {}), ...extra };
}

export const rupees = (paise) =>
  `₹${(Number(paise || 0) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const statisticsApi = {
  summary: (params = {}) => axios.get(`${API}/admin/statistics/summary`, { params, headers: headers() }).then((r) => r.data),
  ledger: (params = {}) => axios.get(`${API}/admin/ledger`, { params, headers: headers() }).then((r) => r.data),
  createExpense: (formData) => axios.post(`${API}/admin/expenses`, formData, { headers: headers({ "Content-Type": "multipart/form-data" }) }).then((r) => r.data),
  voidExpense: (id, reason) => axios.patch(`${API}/admin/expenses/${id}/void`, { reason }, { headers: headers() }).then((r) => r.data),
  categories: (params = {}) => axios.get(`${API}/admin/expense-categories`, { params, headers: headers() }).then((r) => r.data),
  exportUrl: (params = {}) => {
    const qs = new URLSearchParams({ format: "xlsx", ...params }).toString();
    return `${API}/admin/statistics/export?${qs}`;
  },
  downloadExport: async (params = {}) => {
    const format = params.format || "xlsx";
    const r = await axios.get(`${API}/admin/statistics/export`, {
      params: { ...params, format }, headers: headers(), responseType: "blob",
    });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ledger-${new Date().toISOString().slice(0, 10)}.${format}`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  },
};
